import { createFileRoute, redirect } from '@tanstack/react-router';

import { imagesSearchSchema } from '@/features/settings';

/**
 * Kept for links made before spec 224 grouped this page under another entry:
 * Execution images is a tab of Settings, at its own address since spec 227. The
 * search carries over, so a link that opened the add sheet still does.
 */
export const Route = createFileRoute(
  '/workspaces/$workspaceId/execution-images',
)({
  validateSearch: imagesSearchSchema,
  beforeLoad: ({ params, search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/workspaces/$workspaceId/settings/images',
      params: { workspaceId: params.workspaceId },
      search: search.create === true ? { create: true } : {},
      replace: true,
    });
  },
});
